/* unplugin-vue-components disabled */import { render } from "./prompts-list.vue?vue&type=template&id=09bc68ac&scoped=true"
import script from "./prompts-list.vue?vue&type=script&lang=js"
export * from "./prompts-list.vue?vue&type=script&lang=js"

import "./prompts-list.vue?vue&type=style&index=0&id=09bc68ac&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bc68ac"],['__file',"src/components/prompts/prompts-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09bc68ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09bc68ac', __exports__)) {
    api.reload('09bc68ac', __exports__)
  }
  
  module.hot.accept("./prompts-list.vue?vue&type=template&id=09bc68ac&scoped=true", () => {
    api.rerender('09bc68ac', render)
  })

}


export default __exports__